<h1 mat-dialog-title>
    <span translate>ndf.avancesImputables.calculFinal.title</span>
    <span [mat-dialog-close]="false"><i class="zmdi zmdi-close"></i></span>
</h1>
<div mat-dialog-content>
    <div class="listview">
        <div class="listview-body">
            <!-- Ligne Total -->
            <div class="listview-item">
                <div class="lvi-content">
                    <div class="avatar">
                        <i class="nio icon-comptabilisation"></i>
                    </div>
                    <div class="lvi-body">
                        <div class="title">
                            <span class="bold" translate>ndf.avancesImputables.calculFinal.total</span>
                        </div>
                        <ul class="lvi-attrs">
                            <li>
                                <strong translate>ndf.avancesImputables.calculFinal.montantRembDevNote</strong>
                                <span>{{ data.calculFinal.montantRembourseDevNote | montant:data.calculFinal.deviseNote }}</span>
                            </li>
                            <li>
                                <strong translate>ndf.avancesImputables.calculFinal.montantRembDevEntrep</strong>
                                <span>{{ data.calculFinal.montantRembourseDevEntrep | montant:data.calculFinal.deviseEntreprise }}</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <!-- Lignes par devise (mode imputation 1 : par devise) -->
            <ng-container *ngIf="data.calculFinal.modeImputation === ModeImputation.MODE_IMPUTATION_1_MEME_DEVISE">
                <div class="listview-item" *ngFor="let imputation of listeImputations">
                    <div class="lvi-content ms-5">
                        <div class="avatar">
                            <i class="nio icon-note_de_frais"></i>
                        </div>
                        <div class="lvi-body">
                            <div class="title">
                                <span class="bold">{{ imputation.devise }}</span>
                            </div>
                            <ul class="lvi-attrs">
                                <li>
                                    <strong translate>ndf.avancesImputables.calculFinal.noteFrais</strong>
                                    <span>
                                        {{ mapDeviseMontant.get(imputation.devise)?.montant | montant:imputation.devise }}
                                        {{ imputation.devise !== data.calculFinal.deviseEntreprise ? '(' + (mapDeviseMontant.get(imputation.devise)?.montantDevEntrep | montant:data.calculFinal.deviseEntreprise) + ')' : '' }}
                                    </span>
                                </li>
                                <li>
                                    <strong translate>ndf.avancesImputables.calculFinal.avance</strong>
                                    <span>{{ imputation.montantDisponible | montant:imputation.devise }}</span>
                                </li>
                                <li>
                                    <strong translate>ndf.avancesImputables.calculFinal.montantImpute</strong>
                                    <span>{{ imputation.montantImpute | montant:imputation.devise }}</span>
                                </li>
                                <li>
                                    <strong translate>ndf.avancesImputables.calculFinal.montantRestant</strong>
                                    <span>{{ imputation.montantRestant | montant:imputation.devise }}</span>
                                </li>
                                <li>
                                    <strong translate>ndf.avancesImputables.calculFinal.montantARembourser</strong>
                                    <span>{{ imputation.montantRembourseDevEntrep | montant:data.calculFinal.deviseEntreprise }}</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </ng-container>
            <!-- Lignes par devise (mode imputation 2 : solde devise) -->
            <ng-container *ngIf="data.calculFinal.modeImputation === ModeImputation.MODE_IMPUTATION_2_DEVISE_NOTE">
                <!-- Imputations par devise (hors OTHERS) -->
                <div class="listview-item" *ngFor="let imputation of listeImputationsDevise">
                    <div class="lvi-content ms-5">
                        <div class="avatar">
                            <i class="nio icon-note_de_frais"></i>
                        </div>
                        <div class="lvi-body">
                            <div class="title">
                                <span class="bold">{{ imputation.devise }}</span>
                            </div>
                            <ul class="lvi-attrs">
                                <li>
                                    <strong translate>ndf.avancesImputables.calculFinal.noteFrais</strong>
                                    <span>{{ imputation.montantNdfDevEntrep | montant:data.calculFinal.deviseEntreprise }}</span>
                                </li>
                                <li>
                                    <strong translate>ndf.avancesImputables.calculFinal.avance</strong>
                                    <span>{{ imputation.montantDisponible | montant:data.calculFinal.deviseEntreprise }}</span>
                                </li>
                                <li>
                                    <strong translate>ndf.avancesImputables.calculFinal.montantImpute</strong>
                                    <span>{{ imputation.montantImpute | montant:data.calculFinal.deviseEntreprise }}</span>
                                </li>
                                <li>
                                    <strong translate>ndf.avancesImputables.calculFinal.montantRestant</strong>
                                    <span>{{ imputation.montantRestant | montant:data.calculFinal.deviseEntreprise }}</span>
                                </li>
                                <li>
                                    <strong translate>ndf.avancesImputables.calculFinal.montantARembourser</strong>
                                    <span>{{ imputation.montantRembourseDevEntrep | montant:data.calculFinal.deviseEntreprise }}</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <!-- Ligne "Autres devises" (OTHERS) avec détail collapsible -->
                <ng-container *ngIf="imputationOthers">
                    <div class="listview-item">
                        <div class="lvi-content ms-5">
                            <div class="avatar">
                                <i class="nio icon-note_de_frais"></i>
                            </div>
                            <div class="lvi-body">
                                <div class="title">
                                    <span class="bold" translate>ndf.avancesImputables.calculFinal.autresDevises</span>
                                </div>
                                <ul class="lvi-attrs">
                                    <li>
                                        <strong translate>ndf.avancesImputables.calculFinal.noteFrais</strong>
                                        <span>{{ imputationOthers.montantNdfDevEntrep | montant:data.calculFinal.deviseEntreprise }}</span>
                                    </li>
                                    <li>
                                        <strong translate>ndf.avancesImputables.calculFinal.avance</strong>
                                        <span>{{ imputationOthers.montantDisponible | montant:data.calculFinal.deviseEntreprise }}</span>
                                    </li>
                                    <li>
                                        <strong translate>ndf.avancesImputables.calculFinal.montantImpute</strong>
                                        <span>{{ imputationOthers.montantImpute | montant:data.calculFinal.deviseEntreprise }}</span>
                                    </li>
                                    <li>
                                        <strong translate>ndf.avancesImputables.calculFinal.montantRestant</strong>
                                        <span>{{ imputationOthers.montantRestant | montant:data.calculFinal.deviseEntreprise }}</span>
                                    </li>
                                    <li>
                                        <strong translate>ndf.avancesImputables.calculFinal.montantARembourser</strong>
                                        <span>{{ imputationOthers.montantRembourseDevEntrep | montant:data.calculFinal.deviseEntreprise }}</span>
                                    </li>
                                </ul>
                            </div>
                            <!-- Chevron pour ouvrir/fermer le détail par devise -->
                            <div class="lvi-actions">
                                <button mat-icon-button (click)="toggleOthersDetail()">
                                    <mat-icon *ngIf="isOthersDetailOpen" color="primary">keyboard_arrow_up</mat-icon>
                                    <mat-icon *ngIf="!isOthersDetailOpen" color="primary">keyboard_arrow_down</mat-icon>
                                </button>
                            </div>
                        </div>
                    </div>
                    <!-- Détail par devise étrangère -->
                    <ng-container *ngIf="isOthersDetailOpen">
                        <div class="listview-item" *ngFor="let deviseMontant of getDevisesNonAffichees()">
                            <div class="lvi-content ms-5 ps-5">
                                <div class="avatar">
                                    <i class="nio icon-note_de_frais"></i>
                                </div>
                                <div class="lvi-body">
                                    <div class="title">
                                        <span class="bold">{{ deviseMontant.devise }}</span>
                                    </div>
                                    <ul class="lvi-attrs">
                                        <li>
                                            <strong translate>ndf.avancesImputables.calculFinal.noteFrais</strong>
                                            <span>
                                                {{ deviseMontant.montant | montant:deviseMontant.devise }}
                                                {{ deviseMontant.devise !== data.calculFinal.deviseEntreprise ? '(' + (deviseMontant.montantDevEntrep | montant:data.calculFinal.deviseEntreprise) + ')' : '' }}
                                            </span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                </ng-container>
            </ng-container>
            <!-- Ligne "Total dépenses" (mode imputation 3 : solde avance) -->
            <ng-container *ngIf="data.calculFinal.modeImputation === ModeImputation.MODE_IMPUTATION_3_TOUTES_DEVISES">
                <div class="listview-item" *ngFor="let imputation of listeImputations">
                    <div class="lvi-content ms-5">
                        <div class="avatar">
                            <i class="nio icon-note_de_frais"></i>
                        </div>
                        <div class="lvi-body">
                            <div class="title">
                                <span class="bold" translate>ndf.avancesImputables.calculFinal.totalDepenses</span>
                            </div>
                            <ul class="lvi-attrs">
                                <li>
                                    <strong translate>ndf.avancesImputables.calculFinal.noteFrais</strong>
                                    <span>{{ imputation.montantNdfDevEntrep | montant:data.calculFinal.deviseEntreprise }}</span>
                                </li>
                                <li>
                                    <strong translate>ndf.avancesImputables.calculFinal.avance</strong>
                                    <span>{{ imputation.montantDisponible | montant:data.calculFinal.deviseEntreprise }}</span>
                                </li>
                                <li>
                                    <strong translate>ndf.avancesImputables.calculFinal.montantImpute</strong>
                                    <span>{{ imputation.montantImpute | montant:data.calculFinal.deviseEntreprise }}</span>
                                </li>
                                <li>
                                    <strong translate>ndf.avancesImputables.calculFinal.montantRestant</strong>
                                    <span>{{ imputation.montantRestant | montant:data.calculFinal.deviseEntreprise }}</span>
                                </li>
                                <li>
                                    <strong translate>ndf.avancesImputables.calculFinal.montantARembourser</strong>
                                    <span>{{ imputation.montantRembourseDevEntrep | montant:data.calculFinal.deviseEntreprise }}</span>
                                </li>
                            </ul>
                        </div>
                        <!-- Chevron pour ouvrir/fermer le détail des dépenses par devise -->
                        <div class="lvi-actions">
                            <button mat-icon-button (click)="toggleDepensesDetail()">
                                <mat-icon *ngIf="isDepensesDetailOpen" color="primary">keyboard_arrow_up</mat-icon>
                                <mat-icon *ngIf="!isDepensesDetailOpen" color="primary">keyboard_arrow_down</mat-icon>
                            </button>
                        </div>
                    </div>
                </div>
                <!-- Détail des dépenses par devise -->
                <ng-container *ngIf="isDepensesDetailOpen">
                    <div class="listview-item" *ngFor="let deviseMontant of data.calculFinal.listeDeviseMontant">
                        <div class="lvi-content ms-5 ps-5">
                            <div class="avatar">
                                <i class="nio icon-note_de_frais"></i>
                            </div>
                            <div class="lvi-body">
                                <div class="title">
                                    <span class="bold">{{ deviseMontant.devise }}</span>
                                </div>
                                <ul class="lvi-attrs">
                                    <li>
                                        <strong translate>ndf.avancesImputables.calculFinal.noteFrais</strong>
                                        <span>
                                            {{ deviseMontant.montant | montant:deviseMontant.devise }}
                                            {{ deviseMontant.devise !== data.calculFinal.deviseEntreprise ? '(' + (deviseMontant.montantDevEntrep | montant:data.calculFinal.deviseEntreprise) + ')' : '' }}
                                        </span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </ng-container>
        </div>
    </div>
</div>
<div mat-dialog-actions>
    <button mat-stroked-button [mat-dialog-close]="false">
        <span translate>global.actions.annuler</span>
    </button>
    <button mat-flat-button color="primary" [mat-dialog-close]="true">
        <span translate>global.actions.confirmer</span>
    </button>
</div>
